import React, { useState } from 'react';
import { ICON_NEW } from '../extras/icons';
import MainContent from '../layout/MainContent';
import InhibitionList from './inhibitions/InhibitionList';
import InhibitionForm from './inhibitions/InhibitionForm';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { addInhibitionsAction } from '../../actions/inhibitionsActions';
import AuthoritiesService from '../../services/AuthoritiesService';
import { INHIBICIONES_CREAR, PARAMETROS_CREAR } from '../../data/objects';
//Función principal
const Inhibitions = () => {
    //Inicializo el state local
    const [show, setShow] = useState(false);
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Tomo el store
    const authorities = useSelector(state => state.auth.authorities);
    //Manejo el insert
    const handleCreate = () => {
        //Llamo al dispatch
        dispatch( addInhibitionsAction(handleOpen) );
    }
    //Nodos
    const nodes = [];
    //Actions
    const actions = [{
        title: 'NUEVO',
        css: 'success',
        icon: <ICON_NEW className="fa-sm text-white-50" />,
        handle: handleCreate,
        granted: authorities && AuthoritiesService.hasPermission(authorities, INHIBICIONES_CREAR)
    }];
    //Manejo la apertura de la ventana
    const handleOpen = () => {
        setShow(true);
    }
    //Manejo el cierre de la ventana
    const handleClose = () => {
        setShow(false);
    }
    //Renderizo
    return (
        <React.Fragment>
            <MainContent 
                title='Inhibiciones' 
                subtitle='Utilidades' 
                nodes={nodes}
                actions={actions}
                component={InhibitionList}
                handleOpen={handleOpen}
                handleClose={handleClose}
            />

            <InhibitionForm
                show={show}
                handleClose={handleClose}
            />
        </React.Fragment>
    );
};

export default Inhibitions;